import { render, staticRenderFns } from "./AdminOidcConsent.vue?vue&type=template&id=3128f296&scoped=true&"
import script from "./AdminOidcConsent.vue?vue&type=script&lang=ts&"
export * from "./AdminOidcConsent.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOidcConsent.vue?vue&type=style&index=0&id=3128f296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3128f296",
  null
  
)

export default component.exports